/*!
 * devextreme-angular
 * Version: 26.1.6
 * Build date: Fri Oct 16 2026
 *
 * Copyright (c) 2012 - 2026 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/DevExtreme
 */

/* tslint:disable:max-line-length */

/* tslint:disable:use-input-property-decorator */

import {
    Component,
    OnInit,
    OnDestroy,
    NgModule,
    Host,
    SkipSelf
} from '@angular/core';





import {
    DxIntegrationModule,
    NestedOptionHost,
} from 'devextreme-angular/core';
import { DxoChartCommonSeriesSettings } from './base/chart-common-series-settings';


@Component({
    selector: 'dxo-stackedsplinearea',
    template: '',
    styles: [''],
    imports: [ DxIntegrationModule ],
    providers: [NestedOptionHost],
    inputs: [
        'aggregation',
        'area',
        'argumentField',
        'axis',
        'bar',
        'barOverlapGroup',
        'barPadding',
        'barWidth',
        'border',
        'bubble',
        'candlestick',
        'closeValueField',
        'color',
        'cornerRadius',
        'dashStyle',
        'fullstackedarea',
        'fullstackedbar',
        'fullstackedline',
        'fullstackedspline',
        'fullstackedsplinearea',
        'highValueField',
        'hoverMode',
        'hoverStyle',
        'ignoreEmptyPoints',
        'innerColor',
        'label',
        'line',
        'lowValueField',
        'maxLabelCount',
        'minBarSize',
        'opacity',
        'openValueField',
        'pane',
        'point',
        'rangearea',
        'rangebar',
        'rangeValue1Field',
        'rangeValue2Field',
        'reduction',
        'scatter',
        'selectionMode',
        'selectionStyle',
        'showInLegend',
        'sizeField',
        'spline',
        'splinearea',
        'stack',
        'stackedarea',
        'stackedbar',
        'stackedline',
        'stackedspline',
        'stackedsplinearea',
        'steparea',
        'stepline',
        'stock',
        'tagField',
        'type',
        'valueErrorBar',
        'valueField',
        'visible',
        'width'
    ]
})
export class DxoStackedsplineareaComponent extends DxoChartCommonSeriesSettings implements OnDestroy, OnInit  {

    protected get _optionPath() {
        return 'stackedsplinearea';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }


    ngOnInit() {
        this._addRecreatedComponent();
    }

    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }


}

@NgModule({
  imports: [
    DxoStackedsplineareaComponent
  ],
  exports: [
    DxoStackedsplineareaComponent
  ],
})
export class DxoStackedsplineareaModule { }
